import { Route } from '@angular/router';
import { ProductCategoriesComponent } from '../../../../../pages/datasets/product-categories/product-categories.component';
import { ProductCategoriesEditComponent } from '../../../../../pages/datasets/product-categories-edit/product-categories-edit.component';
import { RoutingID } from '../../../../sb-routing-enum';
import { SbIcons } from '@ngx-seatback/icons';

export const productCategories: Route = {
  path: 'productCategories',
  title: 'lang.globals.productCategory',
  data: {
    icon: SbIcons.productCategory,
    breadcrumb: 'lang.globals.productCategory',
    id: RoutingID.productCategories,
  },
  children: [
    {
      path: '',
      component: ProductCategoriesComponent,
      data: {
        breadcrumb: '',
      },
    },
    {
      path: 'productCategories-edit/:productCategoryID',
      title: 'lang.globals.productCategory.edit',
      data: {
        icon: SbIcons.edit,
        breadcrumb: 'lang.globals.productCategory.edit',
        id: RoutingID.productCategoryEdit,
      },
      children: [
        {
          path: '',
          component: ProductCategoriesEditComponent,
          data: {
            breadcrumb: '',
          },
        },
      ],
    },
    {
      path: 'productCategories-create',
      title: 'lang.globals.productCategory.create',
      data: {
        icon: SbIcons.plus,
        breadcrumb: 'lang.globals.productCategory.create',
        id: RoutingID.productCategoryCreate,
      },
      children: [
        {
          path: '',
          component: ProductCategoriesEditComponent,
          data: {
            breadcrumb: '',
          },
        },
      ],
    },
  ],
};
